import { baseApi } from "src/core/api/base";
import { DocumentConfig } from "src/core/interfaces/Document";

const DOCUMENT_CONFIG_ENDPOINT = "/document/private/config";

const documentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    postDocuments: builder.mutation<
      { success: boolean },
      { documentTypeCode: string; data: FormData; entityId: string; expirationDate?: string }
    >({
      query: ({ documentTypeCode, data, entityId, expirationDate }) => {
        let url = `/v1/documents?documentTypeCode=${documentTypeCode}&entityId=${entityId}`;
        if (expirationDate) {
          url += `&expirationDate=${expirationDate}`;
        }
        return {
          url,
          method: "POST",
          body: data,
        };
      },
      extraOptions: {},
    }),
    getDocumentFile: builder.query<Blob, { documentId: string }>({
      query: ({ documentId }) => ({
        url: `/v1/documents/${documentId}`,
        method: "GET",
        responseHandler: async (response: Response) => await response.blob(),
      }),
      extraOptions: {},
      keepUnusedDataFor: 300,
    }),
    getDocumentConfig: builder.query<DocumentConfig, void>({
      query: () => ({
        url: DOCUMENT_CONFIG_ENDPOINT,
        method: "GET",
      }),
      extraOptions: {},
    }),
  }),
});

export const {
  usePostDocumentsMutation,
  useGetDocumentConfigQuery,
  useGetDocumentFileQuery,
  useLazyGetDocumentFileQuery,
} = documentsApi;
